import {WalkthroughDefinition} from '../types';

export const MATCHES_TOUR_TARGETS = {
  title: 'matches.title',
  stats: 'matches.stats',
  board: 'matches.board',
  boardLayoutToggle: 'matches.boardLayoutToggle',
  filters: 'matches.filters',
  cardScores: 'matches.card.scores',
  cardDownloadProfile: 'matches.card.downloadProfile',
  cardExpandableSections: 'matches.card.expandableSections',
  cardActionReject: 'matches.card.action.reject',
  cardActionApprove: 'matches.card.action.approve',
  cardActionToProfile: 'matches.card.action.toProfile',
  viewToggle: 'matches.viewToggle',
  table: 'matches.table',
  tableFilters: 'matches.tableFilters',
  tableList: 'matches.tableList',
  tableAction: 'matches.tableAction',
} as const;

export const companyMatchesWalkthrough: WalkthroughDefinition = {
  id: 'companyMatches',
  version: 4,
  steps: [
    {
      target: MATCHES_TOUR_TARGETS.title,
      titleKey: 'walkthrough.matches.welcome.title',
      bodyKey: 'walkthrough.matches.welcome.body',
      placement: 'bottom-start',
    },
    {
      target: MATCHES_TOUR_TARGETS.stats,
      titleKey: 'walkthrough.matches.stats.title',
      bodyKey: 'walkthrough.matches.stats.body',
      placement: 'bottom',
    },
    {
      target: MATCHES_TOUR_TARGETS.filters,
      titleKey: 'walkthrough.matches.filters.title',
      bodyKey: 'walkthrough.matches.filters.body',
      placement: 'bottom',
    },
    {
      target: MATCHES_TOUR_TARGETS.board,
      titleKey: 'walkthrough.matches.board.title',
      bodyKey: 'walkthrough.matches.board.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.boardLayoutToggle,
      titleKey: 'walkthrough.matches.boardLayoutToggle.title',
      bodyKey: 'walkthrough.matches.boardLayoutToggle.body',
      placement: 'bottom',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardScores,
      titleKey: 'walkthrough.matches.cardScores.title',
      bodyKey: 'walkthrough.matches.cardScores.body',
      placement: 'left',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardDownloadProfile,
      titleKey: 'walkthrough.matches.cardDownloadProfile.title',
      bodyKey: 'walkthrough.matches.cardDownloadProfile.body',
      placement: 'left',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardExpandableSections,
      titleKey: 'walkthrough.matches.cardExpandableSections.title',
      bodyKey: 'walkthrough.matches.cardExpandableSections.body',
      placement: 'left',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardActionReject,
      titleKey: 'walkthrough.matches.cardActionReject.title',
      bodyKey: 'walkthrough.matches.cardActionReject.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardActionApprove,
      titleKey: 'walkthrough.matches.cardActionApprove.title',
      bodyKey: 'walkthrough.matches.cardActionApprove.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.cardActionToProfile,
      titleKey: 'walkthrough.matches.cardActionToProfile.title',
      bodyKey: 'walkthrough.matches.cardActionToProfile.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.viewToggle,
      titleKey: 'walkthrough.matches.viewToggle.title',
      bodyKey: 'walkthrough.matches.viewToggle.body',
      placement: 'left',
    },
    {
      target: MATCHES_TOUR_TARGETS.table,
      titleKey: 'walkthrough.matches.table.title',
      bodyKey: 'walkthrough.matches.table.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.tableFilters,
      titleKey: 'walkthrough.matches.tableFilters.title',
      bodyKey: 'walkthrough.matches.tableFilters.body',
      placement: 'bottom',
    },
    {
      target: MATCHES_TOUR_TARGETS.tableList,
      titleKey: 'walkthrough.matches.tableList.title',
      bodyKey: 'walkthrough.matches.tableList.body',
      placement: 'top',
    },
    {
      target: MATCHES_TOUR_TARGETS.tableAction,
      titleKey: 'walkthrough.matches.tableAction.title',
      bodyKey: 'walkthrough.matches.tableAction.body',
      placement: 'left',
    },
  ],
};
